import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { PageContainer, PageHeader } from "@fleet/ui";
import { CashboxManager } from "@/features/cashbox/components/cashbox-manager";
import { RestaurantGate } from "@/features/pos/components/restaurant-gate";
import { useActiveContext } from "@/features/pos/hooks/use-active-context";
import { useI18n } from "@/providers/i18n-provider";

function CashboxPage() {
  const { t } = useI18n();
  const ctx = useActiveContext();
  return (
    <PageContainer maxWidth="2xl">
      <PageHeader title={t(msg`Cashbox`)} />
      <RestaurantGate ctx={ctx}>
        {(c) => <CashboxManager org={c.org} branch={c.branch} />}
      </RestaurantGate>
    </PageContainer>
  );
}

export const cashboxRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/cashbox",
  component: CashboxPage,
});
